import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ComponentFactoryResolver,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import * as moment from 'moment';
import { animate } from '@angular/animations';
import { style } from '@angular/animations';
import { state } from '@angular/animations';
import { trigger } from '@angular/animations';
import { transition } from '@angular/animations';
import { ITableColumn } from '@app/core/model/utility';
import { newChartColors } from '@app/core/enum/colors';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class TableComponent implements OnInit, OnChanges {
  value: string;
  highlightsConditions: any;

  showSubMenu: boolean = false;
  columnToSort: string = '';
  arrowSortDirection: string = null;
  oldData: any[];
  defaultPaginatorItemsPerPage: number = 5;

  paginatorOptions: any = {
    pageIndex: 0,
    pageSize: 5,
    pageSizeOptions: [5, 10, 25, 50],
  };

  chartColors: string[] = newChartColors;

  pageIndexForChartColor: number = 0;

  activeSort: Sort;

  @Input() total: any;
  @Input() loader: boolean;
  @Input() columns: ITableColumn[];
  @Input() data: any[];
  @Input() dataColor: string;
  @Input() columnsButtons: any;
  @Input() columnsButtonsWithHeading: any;
  @Input() columnCheckbox: any;
  @Input() paginator: boolean = true;
  @Input() specialSorting: any = false;
  @Input() rowBadgeNewElements: boolean = false;
  @Input() pageIndex: number = 0;
  @Input() pageSize: number = 5;
  @Input()
  set highlightsRowsConditions(data) {
    this.highlightsConditions = data;
  }
  get highlightsRowsConditions(): any {
    return this.highlightsConditions;
  }
  @Input()
  set searchValue(value: string) {
    this.value = value;
  }
  get searchValue(): string {
    return this.value;
  }

  @Output() pageIsChanged: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('paginator') paginatorElement: MatPaginator;

  constructor(
    private resolver: ComponentFactoryResolver
  ) {}

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.data?.currentValue) {
      this.oldData = changes.data.currentValue;
      this.pageChanged({
        pageIndex: 0,
        pageSize: this.pageSize,
        length: this.oldData?.length,
      });
    }
    if (changes?.pageIndex?.currentValue) {
      setTimeout(() => {
        for (let step = 0; step < changes?.pageIndex?.currentValue; step++) {
          this.paginatorElement.nextPage();
        }
      }, 100);
    }
  }

  pageChanged(event: PageEvent): void {
    const data = [...this.oldData];
    let sortedData: any[];
    if (this.activeSort?.active) {
      sortedData = data.sort((a: any, b: any) => {
        const isAsc = this.activeSort.direction === 'asc';
        return (
          (a[this.activeSort.active] < b[this.activeSort.active] ? -1 : 1) *
          (isAsc ? 1 : -1)
        );
      });
    } else {
      sortedData = data;
    }
    this.data = sortedData.splice(
      event.pageIndex * event.pageSize,
      event.pageSize
    );
    // this.data = data.splice(event.pageIndex * event.pageSize, event.pageSize);
    this.pageIndexForChartColor = event.pageIndex;
    this.pageIsChanged.emit(event);
  }

  workItemBenchmark(item: any): number {
    let result: number = 0;
    let fav: number;
    let sfav: number;
    let splittedString: string[];
    if (item?.includes(',')) {
      splittedString = item?.split(',');
      splittedString?.forEach((bench: string) => {
        if (bench.includes('F') && !bench.includes('S')) {
          if (bench.includes('()')) {
            fav = parseInt(
              bench.substring(bench.indexOf('(') + 1, bench.lastIndexOf(')')),
              10
            );
          } else {
            fav = 1;
          }
        } else if (bench.includes('SF')) {
          if (bench.includes('()')) {
            sfav = parseInt(
              bench.substring(bench.indexOf('(') + 1, bench.lastIndexOf(')')),
              10
            );
          } else {
            sfav = 1;
          }
        } else {
          result = 0;
        }
      });
    } else {
      if (item?.includes('F') && !item?.includes('S')) {
        if (item?.includes('()')) {
          fav = parseInt(
            item.substring(item.indexOf('(') + 1, item.lastIndexOf(')')),
            10
          );
        } else {
          fav = 1;
        }
      } else if (item?.includes('SF')) {
        if (item?.includes('()')) {
          sfav = parseInt(
            item.substring(item.indexOf('(') + 1, item.lastIndexOf(')')),
            10
          );
        } else {
          sfav = 1;
        }
      } else {
        result = 0;
      }
    }
    if (fav) {
      result = fav + 1000;
    }
    if (!fav && sfav) {
      result = sfav + 10;
    }
    return result;
  }

  checkIfIcon(row: any, column: any): boolean {
    if (
      typeof row[column.name] === 'string' ||
      row[column.name] instanceof String
    ) {
      if (row[column.name]?.includes('icon')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  sortData(sort: Sort): any {
    this.activeSort = sort;
      const data = this.oldData.slice();
      if (!sort.active || sort.direction === '') {
        this.activeSort = null;
        this.data = data.splice(
          this.paginatorElement?.pageIndex * this.paginatorElement?.pageSize,
          this.paginatorElement?.pageSize
        );
        this.sortByColumn(sort.active, this.oldData)
        return;
      }

      const sortedData: any[] = data.sort((a: any, b: any) => {
        const isAsc = sort.direction === 'asc';
        return (a[sort.active] < b[sort.active] ? -1 : 1) * (isAsc ? 1 : -1);
      });
      this.data = sortedData.splice(
        this.paginatorElement?.pageIndex * this.paginatorElement?.pageSize,
        this.paginatorElement?.pageSize
      );

    if (this.specialSorting) {
      const column = sort.active;
        this.sortByColumn(column, this.oldData)
    }

  }

  sortByColumn(column: string, paginatedData): void {
    if (this.arrowSortDirection === null) {
      this.arrowSortDirection = 'expand_less';
       if (column === 'countryName') {
        this.data.sort((a, b) => {
          if (a.countryName > b.countryName) {
            return 1;
          }
          if (a.countryName < b.countryName) {
            return -1;
          }
          return 0;
        });
      } else if (column === 'valueTrend') {
        const valueTrendSorting =  this.specialSorting.sort((a, b) => {
          return a['positionTrend'] - b['positionTrend'];
        });
        const tempSorting = valueTrendSorting.slice(0, this.pageSize);
        const temp = [];
         tempSorting.forEach(function(key) {
          paginatedData.filter(function(item) {
            if(item['countryName'] == key.countryName) {
              temp.push(item);
              return false;
            } else
              return true;
          })
        })
        this.data = temp
      } else if( column === 'valueSaldoProCapite') {
        const valueSaldoProCapiteSorting = this.specialSorting.sort((a, b) => {
          return a['positionSaldoProCapite'] - b['positionSaldoProCapite'];
        });
        const tempSorting = valueSaldoProCapiteSorting.slice(0, this.pageSize);
        const temp = [];
         tempSorting.forEach(function(key) {
          paginatedData.filter(function(item) {
            if(item['countryName'] == key.countryName) {
              temp.push(item);
              return false;
            } else
              return true;
          })
        })
        this.data = temp

      } else if( column === 'valueSaldo') {
        /* BALANCE */
       const balanceSorting = this.specialSorting.sort((a, b) => {
          return a['positionSaldo'] - b['positionSaldo'];
        });
        const temp = [];
        const tempSorting = balanceSorting.slice(0, this.pageSize);
         tempSorting.forEach(function(key) {
          paginatedData.filter(function(item) {
            if(item['countryName'] == key.countryName) {
              temp.push(item);
              return false;
            } else
              return true;
          })
        })
        this.data = temp
      } else {
        this.data.sort((a, b) => {
          return a[column] - b[column];
        });
      }
      return;
    }
    if (this.arrowSortDirection === 'expand_less') {
      this.arrowSortDirection = 'expand_more';

       if (column === 'potentialMarkets') {
        this.data.sort((a, b) => {
          return (
            b.sortByPotential - a.sortByPotential ||
            b.levelOfInterest - a.levelOfInterest
          );
        })
        return;
      }  else if (column === 'countryName') {
        this.data.sort((a, b) => {
          if (b.countryName > a.countryName) {
            return 1;
          }
          if (b.countryName < a.countryName) {
            return -1;
          }
          return 0;
        })
      } else if (column === 'valueTrend') {
        const valueTrendSorting =
          this.specialSorting.sort((a, b) => {
          return b['positionTrend'] - a['positionTrend'];
        }).slice(0, this.pageSize);

        let temp = [];
        let tempSorting = valueTrendSorting
         tempSorting.forEach(function(key) {
          paginatedData.filter(function(item) {
            if(item['countryName'] == key.countryName) {
              temp.push(item);
              return false;
            } else
              return true;
          })
        })
        this.data = temp;
      } else if( column === 'valueSaldoProCapite') {
        const valueSaldoProCapiteSorting =
          this.specialSorting.sort((a, b) => {
          return b['positionSaldoProCapite'] - a['positionSaldoProCapite'];
        });

        let temp = [];
        let tempSorting = valueSaldoProCapiteSorting.slice(0, this.pageSize);
         tempSorting.forEach(function(key) {
          paginatedData.filter(function(item) {
            if( item['countryName'] == key.countryName) {
              temp.push(item);
              return false;
            } else
              return true;
          })
        })
        this.data = temp;
      } else if( column === 'valueSaldo') {
        const valueSaldoSorting =
          this.specialSorting.sort((a, b) => {
          return b['positionSaldo'] - a['positionSaldo'];
        });

        let temp = [];
        let tempSorting = valueSaldoSorting.slice(0, this.pageSize);
         tempSorting.forEach(function(key) {
          paginatedData.filter(function(item) {
            if(item['countryName'] == key.countryName) {
              temp.push(item);
              return false;
            } else
              return true;
          })
        })
        this.data = temp;
      } else {
        this.data.sort((a, b) => {
          return b[column] - a[column];
        });
      }
      return;
    }
    if (this.arrowSortDirection === 'expand_more') {
      this.arrowSortDirection = null;
      this.data = this.oldData.slice(0, this.pageSize);
      return;
    }

}}
